'use strict';

var Carousel = require('./lib/carousel');

module.exports = Carousel;



//////////////////
// WEBPACK FOOTER
// ./~/nuka-carousel/index.js
// module id = 370
// module chunks = 1 2